__turbopack_context__.v({
  "className": "orbitron_4c02d22e-module__pfQqsa__className",
});
